module.exports = ".paymentDetailOverrider {\n  padding-right: 30px; }\n  @media only screen and (min-width: 0px) and (max-width: 800px) {\n    .paymentDetailOverrider {\n      padding-left: 30px;\n      padding-right: 10px; } }\n  .paymentDetailOverrider .approval-code {\n    padding-right: 10px;\n    margin-bottom: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/history_detail.component.scss
// module id = ./src/app/payment/history_detail.component.scss
// module chunks = main